import styled from "styled-components/macro";

export const HeaderContainer = styled.div`
  display: flex;
  height: 48px;
  margin-bottom: 32px;
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 8px;
  justify-content: center;
  h1 {
    color: ${({ theme }) => theme.secondaryTextColor};
    font-size: 20px;
    font-weight: bold;
  }
  p {
    font-size: 14px;
  }
`;

export const InputWrapper = styled.div`
  padding-bottom: 10px;
  text-align: left;

  button {
    border: none;
  }

  input {
    font-family: arial;
    margin-bottom: 2px;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  select#notesToClientShortcuts,
  select#sigShortcuts {
    width: 57%;
    margin-right: 11px;
  }
`;

export const FooterContainer = styled.div`
  margin-top: 20px;
  justify-content: end;
  display: flex;
`;
